import styled from 'styled-components';
import Detail from '../../../../../_shared/components/Detail';

import Icon from '../../../../../_shared/components/Icon';
import Button from '../../../../../_shared/components/Button';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-height: 75vh;
`;

export const CloseButton = styled.button`
  display: block;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.TRANSPARENT};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding-top: 24px;
  padding-bottom: 36px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  height: 24px;
  line-height: 24px;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  background: ${({ theme }) => theme.COLORS.BASE};
  width: 390px;
  text-align: left;
  padding-left: 0;
`;

export const Content = styled.div`
  width: 100%;
  padding-bottom: 24px;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: 24px;
`;

export const VehicleSeatIcon = styled(Icon).attrs({
  icon: 'TR5-Vehicle-Seat'
})`
  width: 26px;
  height: 36px;
  margin-right: 18px;
`;

export const VinCopyIcon = styled(Icon).attrs({
  icon: 'TR5-Copy_to_clipboard'
})`
  width: 12px;
  margin-left: 6px;
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 10px;
  height: 11px;
  padding-bottom: 1px;
  padding-left: 2px;
`;

export const VehicleInfoDetail = styled(Detail)`
  display: inline-block;
  padding-right: ${props => props.spacing}px;
  line-height: normal;
`;

export const VinButton = styled(Button)`
  text-transform: inherit;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 0;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  cursor: copy;
`;

export const VehicleFeaturesContainer = styled.div`
  border-radius: 9px;
  width: 363px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  padding: 18px;
  margin-bottom: 24px;
`;

export const VehicleFeaturesHeader = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 14px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  padding-bottom: 9px;
`;
